(function() {
  'use strict';

  var colorCache = new Map();

  /* ===== DELIVERY DATE ===== */

  function calculateDeliveryDate() {
    var now = new Date();
    var ukDate = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' }));
    var day = ukDate.getDay(), hour = ukDate.getHours(), add;
    if (day >= 1 && day <= 4) { add = hour < 11 ? 1 : 2; }
    else if (day === 5) { add = hour < 11 ? 3 : 4; }
    else if (day === 6) { add = 3; }
    else { add = 2; }
    var del = new Date(ukDate);
    del.setDate(del.getDate() + add);
    if (del.getDay() === 6) del.setDate(del.getDate() + 2);
    if (del.getDay() === 0) del.setDate(del.getDate() + 1);
    var days = ['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY'];
    var months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    var d = del.getDate(), s = 'TH';
    if (d % 10 === 1 && d !== 11) s = 'ST';
    else if (d % 10 === 2 && d !== 12) s = 'ND';
    else if (d % 10 === 3 && d !== 13) s = 'RD';
    return 'Available for Delivery on ' + days[del.getDay()] + ' ' + d + s + ' ' + months[del.getMonth()];
  }

  function initDeliveryDates() {
    var deliveryText = calculateDeliveryDate();
    document.querySelectorAll('.delivery-date-text').forEach(function(span) {
      if (!span.textContent.trim()) {
        span.textContent = deliveryText;
      }
    });
  }

  /* ===== COLOUR EXTRACTION ===== */

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max === min) {
      h = s = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }
    return [h, s, l];
  }

  function hslToRgb(h, s, l) {
    var r, g, b;
    if (s === 0) {
      r = g = b = l;
    } else {
      var hue2rgb = function(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1/6) return p + (q - p) * 6 * t;
        if (t < 1/2) return q;
        if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
      };
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1/3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1/3);
    }
    return [r * 255, g * 255, b * 255];
  }

  function getAverageColor(imageUrl) {
    if (colorCache.has(imageUrl)) {
      return Promise.resolve(colorCache.get(imageUrl));
    }
    return new Promise(function(resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function() {
        try {
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          var sampleSize = 150;
          var startX = Math.max(0, (img.width / 2) - (sampleSize / 2));
          var startY = Math.max(0, (img.height / 2) - (sampleSize / 2));
          var w = Math.min(sampleSize, img.width - startX);
          var h = Math.min(sampleSize, img.height - startY);
          canvas.width = w;
          canvas.height = h;
          ctx.drawImage(img, startX, startY, w, h, 0, 0, w, h);
          var data = ctx.getImageData(0, 0, w, h).data;
          var r = 0, g = 0, b = 0, count = data.length / 4;
          for (var i = 0; i < data.length; i += 4) {
            r += data[i]; g += data[i + 1]; b += data[i + 2];
          }
          r = Math.round(r / count); g = Math.round(g / count); b = Math.round(b / count);
          var hsl = rgbToHsl(r, g, b);
          hsl[1] = Math.min(1, hsl[1] * 1.5);
          hsl[2] = Math.max(0.2, Math.min(0.8, hsl[2]));
          var rgb = hslToRgb(hsl[0], hsl[1], hsl[2]);
          var color = 'rgb(' + Math.round(rgb[0]) + ',' + Math.round(rgb[1]) + ',' + Math.round(rgb[2]) + ')';
          colorCache.set(imageUrl, color);
          resolve(color);
        } catch (e) { reject(e); }
      };
      img.onerror = reject;
      img.src = imageUrl;
    });
  }

  /* ===== SWATCHES ===== */

  function initSwatches() {
    /* Load colours into swatch buttons */
    document.querySelectorAll('.collection-swatch:not([data-color-loaded])').forEach(function(swatch) {
      swatch.setAttribute('data-color-loaded', 'true');
      var imageUrl = swatch.dataset.variantImage;
      if (imageUrl) {
        getAverageColor(imageUrl).then(function(color) {
          swatch.style.backgroundColor = color;
        }).catch(function() {
          swatch.style.backgroundColor = '#ccc';
        });
      }
    });

    /* Attach click handlers to swatch containers */
    document.querySelectorAll('.collection-swatches:not([data-initialized])').forEach(function(container) {
      container.setAttribute('data-initialized', 'true');
      container.addEventListener('click', function(e) {
        var swatch = e.target.closest('.collection-swatch');
        if (!swatch || swatch.dataset.available === 'false') return;
        e.preventDefault();
        e.stopPropagation();

        /* Visual active state */
        container.querySelectorAll('.collection-swatch').forEach(function(s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');

        var card = container.closest('product-card');
        if (!card) return;

        /* Swap product image */
        var fullImage = swatch.dataset.fullImage;
        if (fullImage) {
          var img = card.querySelector('.product-media__image, img[srcset]');
          if (img) {
            img.srcset = fullImage + ' 1000w';
            img.src = fullImage;
          }
        }

        /* Update all product links with selected variant */
        var variantId = swatch.dataset.variantId;
        if (variantId) {
          var links = card.querySelectorAll('.cta-view, [ref="cardGalleryLink"], [ref="productTitleLink"]');
          links.forEach(function(link) {
            var baseUrl = link.href.split('?')[0];
            link.href = baseUrl + '?variant=' + variantId;
          });
        }
      });
    });
  }


  /* ===== INIT ===== */

  function initAll() {
    initDeliveryDates();
    initSwatches();
  }

  /* Run on initial page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Debounced re-init to avoid rapid successive calls */
  var reinitTimer;
  function scheduleReinit() {
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(initAll, 200);
  }

  /* Watch for infinite scroll (new cards) AND facet morph (in-place updates) */
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mut = mutations[i];

      /* New product cards added (infinite scroll) */
      for (var j = 0; j < mut.addedNodes.length; j++) {
        var node = mut.addedNodes[j];
        if (node.nodeType === 1 && (node.tagName === 'PRODUCT-CARD' || node.tagName === 'LI' || (node.querySelector && node.querySelector('product-card')))) {
          scheduleReinit();
          return;
        }
      }

      /* Morph updated children inside a product card (facets/filters) */
      if (mut.target.closest && mut.target.closest('product-card')) {
        scheduleReinit();
        return;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* Handle Shopify theme editor section reload */
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initAll, 100);
  });

  /* Handle facet filter navigation (back/forward after filtering) */
  window.addEventListener('popstate', function() {
    setTimeout(initAll, 500);
  });
})();
